import poweredByLight from '../../../images/logos/maestro_logo_tagline_grad_white.svg';
import poweredByDark from '../../../images/logos/maestro_logo_tagline_allwhite.svg';
import michelinLogo from '../../../images/logos/bib.jpg';

export const PoweredByLogo = {
  LIGHT: poweredByLight,
  DARK: poweredByDark,
  DEFAULT: michelinLogo,
};
